export default __webpack_public_path__ + "static/media/Hair_17_F_C5.cca6e21c.svg";